export default __webpack_public_path__ + "static/media/scale@3x.c0387551.webp";